import React from "react";
import { Helmet } from "react-helmet-async";
import { posts } from "../data/posts";
import InsightCard from "../components/InsightCard";
import { PageHeader } from "../components/ui";

const DESCRIPTION =
  "Stay up-to-date with Chiparama's latest insights on semiconductor design, automation, and industry trends.";

export default function NewsBlogsPage() {
  return (
    <>
      <Helmet>
        <title>Insights | Semiconductor Engineering Perspectives | Chiparama</title>
        <meta name="description" content={DESCRIPTION} />
        <link rel="canonical" href="https://chiparama.com/news-blogs" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Insights | Semiconductor Engineering Perspectives | Chiparama" />
        <meta property="og:description" content={DESCRIPTION} />
        <meta property="og:url" content="https://chiparama.com/news-blogs" />
        <meta property="og:image" content="https://chiparama.com/chiparamalogo.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Insights | Semiconductor Engineering Perspectives | Chiparama" />
        <meta name="twitter:description" content={DESCRIPTION} />
        <meta name="twitter:image" content="https://chiparama.com/chiparamalogo.jpg" />
      </Helmet>

      <PageHeader eyebrow="Insights" title="Engineering perspectives.">
        Stay up to date with the latest insights from our team and industry experts.
      </PageHeader>

      <section className="section bg-paper">
        <div className="container-x grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {posts.map((p) => (
            <InsightCard key={p.id} post={p} />
          ))}
        </div>
      </section>
    </>
  );
}
